import { render } from "./TiposDocMapeoModal.vue?vue&type=template&id=26133dd4"
import script from "./TiposDocMapeoModal.vue?vue&type=script&lang=js"
export * from "./TiposDocMapeoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__